module.exports = __webpack_public_path__ + "img/page6.5e147cef.jpg";